module.exports = __webpack_public_path__ + "static/img/loading.3016b11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey/images/loading.gif
// module id = l4gH
// module chunks = 0